import React, { useState, useEffect, useRef, createContext } from "react";
import { IntlProvider } from "react-intl";

import { getLanguageFromPath } from "utils/getLanguageFromPath";
import Modal from 'components/Modal/Modal';
import Layout from 'components/Layout'
import { navigate } from 'gatsby';
import locales from "i18n/locales";

import "./src/styles/app.scss";
import "./src/styles/global.css";
import { PresentationContext } from "./src/context/PresentationContext";

const IntlLoader = (props) => {
  const [state, setState] = useState(() => ({
    messages: window.__messages,
    language: window.__language,
  }));

  const loadMessages = async (language) => {
    const messages = await import(`./src/i18n/${language}.json`).default;
    setState({ messages, language });
  };

  useEffect(() => {
    if (state.language !== props.language) {
      loadMessages(props.language);
    }
  }, [props.language, state.language]);

  const { language, ...rest } = props;

  return (
    <IntlProvider
      locale={state.language}
      messages={state.messages}
      key={state.language}
      {...rest}
    />
  );
};

export const wrapPageElement = ({ element, props }) => {
  const { location } = props;

  const { pathname } = location;

  const language = getLanguageFromPath(pathname, locales);

  return (
    <IntlLoader language={language} {...props}>
      <Layout>
        <PresentationContext.Provider value={{ location }}>
          {element}
        </PresentationContext.Provider>
      </Layout>
    </IntlLoader>
  );
};

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location?.state?.shouldPreventScroll) {
    return false;
  }

  return true;
}